import { twMerge } from 'tailwind-merge';
import Avatar from '@mui/material/Avatar';
import CircularProgress from '@mui/material/CircularProgress';
import { getProfilePicUrl } from '@/api/urls';
import type { ProfilePictureUser } from './types';
import { classes, getUserLabels, styles } from './utils';

export type ProfilePictureProps = {
  isLoading?: boolean;
  className?: string;
  size?: number;
  user: ProfilePictureUser;
};

export default function ProfilePicture({
  isLoading,
  className,
  size = 40,
  user,
}: ProfilePictureProps) {
  if (!user) return null;
  const labels = getUserLabels(user);
  const sharedProps = {
    sx: styles.shared(size),
    alt: labels.name,
    className: twMerge(classes.avatar, className),
  };
  const avatarProps = {
    ...sharedProps,
    sx: {
      ...styles.shared(size),
      ...styles.avatar,
    },
  };
  if (isLoading) {
    return (
      <CircularProgress
        sx={styles.circularProgress}
        thickness={2}
        size={size}
      />
    );
  }
  if (user.userPreferences?.profilePicSource) {
    return (
      <Avatar
        src={getProfilePicUrl(user.userPreferences.profilePicSource.value)}
        {...sharedProps}
      />
    );
  }
  return <Avatar {...avatarProps}>{labels.initials}</Avatar>;
}
